import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const getInitialLanguage = () => {
  if (typeof window === 'undefined') return 'en';

  const storedLanguage =
    window.localStorage.getItem('lang') ||
    window.localStorage.getItem('i18nextLng');

  return storedLanguage === 'ar' ? 'ar' : 'en';
};

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: getInitialLanguage(),
  resources: {
    en: {
      translations: require('./locales/en/translations.json'),
      legacyDashboard: {},
    },
    ar: {
      translations: require('./locales/ar/translations.json'),
      legacyDashboard: require('./locales/ar/legacy-dashboard.json'),
    },
  },
  ns: ['translations', 'legacyDashboard'],
  defaultNS: 'translations',
});

i18n.languages = ['en', 'ar'];

i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem('lang', lng);
    window.localStorage.setItem('i18nextLng', lng);
  }

  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  }
});

export default i18n;
